import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { motion } from 'framer-motion'

type GroupButtonProps = {
  unfolded?: boolean
}

const groupButtonUnfolded = ({ unfolded }: GroupButtonProps) =>
  unfolded &&
  css`
    > svg {
      transform: rotateZ(180deg);
    }
  `

const shouldForwardProp = (prop: string | number) => {
  return !['unfolded'].includes(String(prop))
}

export const GroupButton = styled.button.withConfig({
  shouldForwardProp,
})<GroupButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 76px;

  > svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    transform: rotateZ(0deg);
    transition: all ${themeGet('defaultTransitionTime')};
  }

  ${groupButtonUnfolded}
`

export const CollapseContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`
